import React, { useState, useEffect, useRef } from 'react';
import MasterPage from '../../../EstruturaAntiga/masterpages/authenticated';
import LoadingOrErrorPanel from 'components/LoadingOrErrorPanel';
import NovaOperacao from './Components/NovaOperacao';
import OperacaoEmAndamento from './Components/OperacaoEmAndamento';
import OperacaoInvalida from './Components/OperacaoInvalida';
import UsuariosService from 'services/UsuariosService';
import OperacaoFalhou from './Components/OperacaoFalhou';
import ConfirmacaoOperacao from './Components/ConfirmacaoOperacao';
import { ModalErro } from 'components/Modais/ModalErro';
import { Flex, Steps, Typography } from 'antd';
import { useAuth } from 'context/AuthContext';
import BotaoDownload from 'components/Botoes/BotaoDownload/BotaoDownload';
import STATUS from './Constants/status';
import STEPS from './Constants/steps';
import { useRoteiro } from 'context/RoteiroContext';

function CadastroMultiplosUsuarios() {
    const [loading, setLoading] = useState(true);
    const [ultimoLog, setUltimoLog] = useState({});
    const [paginaStatus, setPaginaStatus] = useState('');
    const [stepAtual, setStepAtual] = useState(0);
    const [exibirBotaoBaixarUltimoArquivo, setExibirBotaoBaixarUltimoArquivo] = useState(false);

    const {setReferenciaObjetosVisuais} = useRoteiro();
    const refBotaoBaixarUltimoArquivo = useRef(null);
    const refs = [
        { id: 'refBotaoBaixarUltimoArquivo', ref: refBotaoBaixarUltimoArquivo }
    ];

    const {direito} = useAuth();
    const { Text } = Typography;

    useEffect(()=>{
        atualizarPagina();
    }, []);

    const atualizarPagina = async () => {
        await obterUltimoLog();
        setReferenciaObjetosVisuais(refs);
    }

    const obterUltimoLog = async () => {
        const ultimoLog = await UsuariosService.ObterUltimoLogCriacaoMultiplosUsuarios();

        if (ultimoLog) {
            setUltimoLog(ultimoLog);
            setPaginaStatus(ultimoLog?.statusOperacao);
            setarEtapaAtual(ultimoLog?.statusOperacao);
            setExibirBotaoBaixarUltimoArquivo(true);
        }
        setLoading(false);
    }

    const setarEtapaAtual = (paginaStatus) => {
        switch (paginaStatus) {
            case !paginaStatus:
            case STATUS.PROCESSADO:
            case STATUS.CANCELADO:
                setStepAtual(STEPS.BAIXAR_MODELO);
                break;
            case STATUS.EM_VALIDACAO:
            case STATUS.INVALIDO:
                setStepAtual(STEPS.VALIDACAO);
                break;
            case STATUS.PRONTO_PARA_PROCESSAMENTO:
                setStepAtual(STEPS.CONFIGURACAO);
                break;
            case STATUS.EM_PROCESSAMENTO:
                setStepAtual(STEPS.EM_PROCESSAMENTO);
                break;
            default:
                setStepAtual(STEPS.FALHA);
                break;
        }
    }

    const reiniciarProcesso = () => {
        setPaginaStatus('');
        alterarStepAtual(STEPS.BAIXAR_MODELO);
    }

    const alterarStepAtual = (step) => {
        window.scrollTo(0, 0);
        setStepAtual(step);
    }
    
    const cancelarOperacao = async () => {
        setLoading(true);

        try {
            await UsuariosService.CancelarOperacaoCriacaoMultiplosUsuarios(ultimoLog.logOperacaoId);
        } catch (error) {
            ModalErro('Cancelar operação', error.response?.data?.erros ?? ['Erro inesperado ao cancelar operação']);
        }
        await atualizarPagina();
    }

    const baixarArquivoUltimoLog = async () => {
        return await UsuariosService.GerarLinkDownloadUltimoArquivoMultiplosUsuarios(ultimoLog.logOperacaoId);
    }

    const baixarArquivoErroUltimoLog = async () => {
        return await UsuariosService.GerarLinkDownloadErrosMultiplosUsuarios(ultimoLog.logOperacaoId);
    }

    return(
        <MasterPage useFullWidth={true}>
            <LoadingOrErrorPanel loading={loading}>
                <Flex vertical gap="30px" style={{ marginBottom: 24 }}>
                    <Steps current={stepAtual}>
                        <Steps.Step title="Baixar modelo" disabled={true} />
                        <Steps.Step title="Upload arquivo" disabled={true} />
                        <Steps.Step title="Validação" disabled={true} />
                        <Steps.Step title="Configuração" disabled={true} />
                        <Steps.Step title="Confirmação" disabled={true} />
                        <Steps.Step title="Em processamento" disabled={true} />
                    </Steps>
                    <Flex className='big-gap'>
                        <Text strong>Empresa: {direito.accountName}</Text>
                        <Text strong>Tenant: {direito.tenantName}</Text>
                    </Flex>
                    <Flex justify="flex-start">
                        {exibirBotaoBaixarUltimoArquivo && (
                            <BotaoDownload
                                apiCallback={() => baixarArquivoUltimoLog()}
                                linkName="arquivoUltimoLog"
                                message="Baixar último arquivo enviado"
                                refReact={refBotaoBaixarUltimoArquivo}
                            />
                        )}
                    </Flex>
                {
                    paginaStatus == '' || paginaStatus == STATUS.PROCESSADO || paginaStatus == STATUS.CANCELADO ?
                        <NovaOperacao 
                            stepAtual={stepAtual}
                            setStepAtual={alterarStepAtual}
                            obterUltimoLog={atualizarPagina}
                        /> :
                    paginaStatus == STATUS.FALHOU ?
                        <OperacaoFalhou
                            ultimoLog={ultimoLog}
                        /> :
                    paginaStatus == STATUS.INVALIDO ?
                        <OperacaoInvalida
                            reiniciarProcesso={reiniciarProcesso} 
                            baixarArquivoErroUltimoLog={baixarArquivoErroUltimoLog}
                        /> :
                    paginaStatus == STATUS.PRONTO_PARA_PROCESSAMENTO ?
                        <ConfirmacaoOperacao
                            logOperacao={ultimoLog}
                            stepAtual={stepAtual}
                            setStepAtual={alterarStepAtual}
                            obterUltimoLog={atualizarPagina}
                            cancelarOperacao={cancelarOperacao}
                        /> :
                        <OperacaoEmAndamento
                            ultimoLog={ultimoLog}
                            obterUltimoLog={atualizarPagina}
                            cancelarOperacao={cancelarOperacao}
                        />
                }
                </Flex>
            </LoadingOrErrorPanel>
        </MasterPage>
    )
}

export default CadastroMultiplosUsuarios;